export default {
  ARCHIVE_SHOWCASE: 'office-app/ARCHIVE_SHOWCASE',
  ARCHIVE_SHOWCASE_ERROR: 'office-app/ARCHIVE_SHOWCASE_ERROR',
  ARCHIVE_SHOWCASE_START: 'office-app/ARCHIVE_SHOWCASE_START',
  ARCHIVE_SHOWCASE_SUCCESS: 'office-app/ARCHIVE_SHOWCASE_SUCCESS',
  GET_CATEGORY_AUTOCOMPLETE: 'office-app/GET_CATEGORY_AUTOCOMPLETE',
  GET_CATEGORY_AUTOCOMPLETE_ERROR: 'office-app/GET_CATEGORY_AUTOCOMPLETE_ERROR',
  GET_CATEGORY_AUTOCOMPLETE_START: 'office-app/GET_CATEGORY_AUTOCOMPLETE_START',
  GET_CATEGORY_AUTOCOMPLETE_SUCCESS: 'office-app/GET_CATEGORY_AUTOCOMPLETE_SUCCESS',
  GET_CATEGORY_AUTOCOMPLETE_RESET: 'office-app/GET_CATEGORY_AUTOCOMPLETE_RESET',
  CREATE_LICENSE: 'office-app/CREATE_LICENSE',
  CREATE_LICENSE_ERROR: 'office-app/CREATE_LICENSE_ERROR',
  CREATE_LICENSE_START: 'office-app/CREATE_LICENSE_START',
  CREATE_LICENSE_SUCCESS: 'office-app/CREATE_LICENSE_SUCCESS',
  CREATE_LICENSE_RESET: 'office-app/CREATE_LICENSE_RESET',
  DELETE_LICENSE: 'office-app/DELETE_LICENSE',
  DELETE_LICENSE_ERROR: 'office-app/DELETE_LICENSE_ERROR',
  DELETE_LICENSE_START: 'office-app/DELETE_LICENSE_START',
  DELETE_LICENSE_SUCCESS: 'office-app/DELETE_LICENSE_SUCCESS',
  UPDATE_LICENSE: 'office-app/UPDATE_LICENSE',
  UPDATE_LICENSE_ERROR: 'office-app/UPDATE_LICENSE_ERROR',
  UPDATE_LICENSE_START: 'office-app/UPDATE_LICENSE_START',
  UPDATE_LICENSE_SUCCESS: 'office-app/UPDATE_LICENSE_SUCCESS',
  UPDATE_LICENSE_RESET: 'office-app/UPDATE_LICENSE_RESET',
  UPDATE_LICENSE_ATTESTATION: 'office-app/UPDATE_LICENSE_ATTESTATION',
  UPDATE_LICENSE_ATTESTATION_ERROR: 'office-app/UPDATE_LICENSE_ATTESTATION_ERROR',
  UPDATE_LICENSE_ATTESTATION_START: 'office-app/UPDATE_LICENSE_ATTESTATION_START',
  UPDATE_LICENSE_ATTESTATION_SUCCESS: 'office-app/UPDATE_LICENSE_ATTESTATION_SUCCESS',
  GET_PROFILE: 'office-app/GET_PROFILE',
  GET_PROFILE_ERROR: 'office-app/GET_PROFILE_ERROR',
  GET_PROFILE_START: 'office-app/GET_PROFILE_START',
  GET_PROFILE_SUCCESS: 'office-app/GET_PROFILE_SUCCESS',
  GET_PROFILE_RESET: 'office-app/GET_PROFILE_RESET',
  GET_PROFILE_UAPI: 'office-app/GET_PROFILE_UAPI',
  GET_PROFILE_UAPI_ERROR: 'office-app/GET_PROFILE_UAPI_ERROR',
  GET_PROFILE_UAPI_START: 'office-app/GET_PROFILE_UAPI_START',
  GET_PROFILE_UAPI_SUCCESS: 'office-app/GET_PROFILE_UAPI_SUCCESS',
  GET_PROFILE_UUID: 'office-app/GET_PROFILE_UUID',
  GET_PROFILE_UUID_ERROR: 'office-app/GET_PROFILE_UUID_ERROR',
  GET_PROFILE_UUID_START: 'office-app/GET_PROFILE_UUID_START',
  GET_PROFILE_UUID_SUCCESS: 'office-app/GET_PROFILE_UUID_SUCCESS',
  GET_PROFILE_COMPLETION: 'office-app/GET_PROFILE_COMPLETION',
  GET_PROFILE_COMPLETION_START: 'office-app/GET_PROFILE_COMPLETION_START',
  GET_PROFILE_COMPLETION_SUCCESS: 'office-app/GET_PROFILE_COMPLETION_SUCCESS',
  GET_PROFILE_COMPLETION_RESET: 'office-app/GET_PROFILE_COMPLETION_RESET',
  GET_SHOWCASES: 'office-app/GET_SHOWCASES',
  GET_SHOWCASES_ERROR: 'office-app/GET_SHOWCASES_ERROR',
  GET_SHOWCASES_START: 'office-app/GET_SHOWCASES_START',
  GET_SHOWCASES_SUCCESS: 'office-app/GET_SHOWCASES_SUCESS',
  GET_SHOWCASES_RESET: 'office-app/GET_SHOWCASES_RESET',
  GET_THIMBLE_URL: 'office-app/GET_THIMBLE_URL',
  GET_THIMBLE_URL_ERROR: 'office-app/GET_THIMBLE_URL_ERROR',
  GET_THIMBLE_URL_START: 'office-app/GET_THIMBLE_URL_START',
  GET_THIMBLE_URL_SUCCESS: 'office-app/GET_THIMBLE_URL_SUCESS',
  GET_THIMBLE_URL_RESET: 'office-app/GET_THIMBLE_URL_RESET',
  SAVE_BONDED_INSURED: 'office-app/SAVE_BONDED',
  SAVE_BONDED_INSURED_ERROR: 'office-app/SAVE_BONDED_INSURED_ERROR',
  SAVE_BONDED_INSURED_START: 'office-app/SAVE_BONDED_INSURED_START',
  SAVE_BONDED_INSURED_SUCCESS: 'office-app/SAVE_BONDED_INSURED_SUCCESS',
  SAVE_PROFILE: 'office-app/SAVE_PROFILE',
  SAVE_PROFILE_ERROR: 'office-app/SAVE_PROFILE_ERROR',
  SAVE_PROFILE_START: 'office-app/SAVE_PROFILE_START',
  SAVE_PROFILE_SUCCESS: 'office-app/SAVE_PROFILE_SUCCESS',
  SAVE_PROFILE_RESET: 'office-app/SAVE_PROFILE_RESET',
  SAVE_SERVICES: 'office-app/SAVE_SERVICES',
  SAVE_SERVICES_ERROR: 'office-app/SAVE_SERVICES_ERROR',
  SAVE_SERVICES_START: 'office-app/SAVE_SERVICES_START',
  SAVE_SERVICES_SUCCESS: 'office-app/SAVE_SERVICES_SUCCESS',
  SAVE_SERVICES_RESET: 'office-app/SAVE_SERVICES_RESET',
  SAVE_LICENSE: 'office-app/SAVE_LICENSE',
  SAVE_LICENSE_ERROR: 'office-app/SAVE_LICENSE_ERROR',
  SAVE_LICENSE_START: 'office-app/SAVE_LICENSE_START',
  SAVE_LICENSE_SUCCESS: 'office-app/SAVE_LICENSE_SUCCESS',
  SAVE_LICENSE_RESET: 'office-app/SAVE_LICENSE_RESET',
  SAVE_HEALTH_SETTINGS: 'office-app/SAVE_HEALTH_SETTINGS',
  SAVE_HEALTH_SETTINGS_ERROR: 'office-app/SAVE_HEALTH_SETTINGS_ERROR',
  SAVE_HEALTH_SETTINGS_START: 'office-app/SAVE_HEALTH_SETTINGS_START',
  SAVE_HEALTH_SETTINGS_SUCCESS: 'office-app/SAVE_HEALTH_SETTINGS_SUCCESS',
  SAVE_HEALTH_SETTINGS_RESET: 'office-app/SAVE_HEALTH_SETTINGS_RESET',
  SHOWCASE_ADVERTISE_REQUEST: 'office-app/SHOWCASE_ADVERTISE_REQUEST',
  SHOWCASE_ADVERTISE_REQUEST_ERROR: 'office-app/SHOWCASE_ADVERTISE_REQUEST_ERROR',
  SHOWCASE_ADVERTISE_REQUEST_START: 'office-app/SHOWCASE_ADVERTISE_REQUEST_START',
  SHOWCASE_ADVERTISE_REQUEST_SUCCESS: 'office-app/SHOWCASE_ADVERTISE_REQUEST_SUCCESS',
  SHOWCASE_ADVERTISE_REQUEST_RESET: 'office-app/SHOWCASE_ADVERTISE_REQUEST_RESET',
  GET_ALL_BUSINESS_HIGHLIGHTS: 'office-app/GET_ALL_BUSINESS_HIGHLIGHTS',
  SAVE_BUSINESS_HIGHLIGHTS: 'office-app/SAVE_BUSINESS_HIGHLIGHTS',
  SAVE_BUSINESS_HIGHLIGHTS_SUCCESS: 'office-app/SAVE_BUSINESS_HIGHLIGHTS_SUCCESS',
  GET_JWT: 'office-app/JWT',
  GET_JWT_SUCCESS: 'office-app/JWT_SUCCESS',
  GET_JWT_ERROR: 'office-app/JWT_ERROR',
};



// WEBPACK FOOTER //
// ./src/modules/profile/common/profileActionKeys.js